import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Videos from "../Videos/Videos";
import { ApiFetch } from "../../utils/ApiFetch/ApiFetch";
import { useParams } from "react-router-dom";

function SearchFeed() {
  const [videos, setVideos] = useState([]);
  const { searchTerm } = useParams();

  useEffect(() => {
    ApiFetch(`search?part=snippet&q=${searchTerm}`).then((data) =>
      setVideos(data.items)
    );
  }, [searchTerm]);
  return (
    <Box p={2} sx={{ overflowY: "auto", height: "90vh" }}>
      <Typography variant="h4" fontWeight="bold" md={2} sx={{ color: "white" }}>
        search result for:
        <span style={{ color: "#F31503" }}>{searchTerm}</span>Videos
      </Typography>

      <Videos videos={videos} />
    </Box>
  );
}

export default SearchFeed;
